import { render, staticRenderFns } from "./pexpansion.vue?vue&type=template&id=0fba424c&scoped=true&"
import script from "./pexpansion.vue?vue&type=script&lang=js&"
export * from "./pexpansion.vue?vue&type=script&lang=js&"
import style0 from "./pexpansion.vue?vue&type=style&index=0&id=0fba424c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fba424c",
  null
  
)

export default component.exports